import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { SEOService } from '../../../../services/seo.service';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss'],
  imports: [LottieComponent, TranslocoPipe, RouterLink],
})
export class Error404Component {
  private seoService = inject(SEOService);
  private translateService = inject(TranslocoService);

  animation: AnimationOptions = {
    path: './assets/animations/error-pages-tool/404.json',
  };

  constructor() {
    this.seoService.updateTitle(this.translateService.translate('jobboard.views.errors.404.not-found'));
    this.seoService.updateDescription('');
  }
}
